module.exports = __webpack_public_path__ + "img/fuxiaoyun.44ec91e8.jpg";